<template>
    <div>
        <b-modal ref="mdlcodiceAic" id="mdlcodiceAic" title="Selezione Farmaco - Banca Dati" size="lg" scrollable no-close-on-backdrop no-close-on-esc hide-header-close centered @shown="onShown" modal-class="sa-modal-bancafarmaci" hide-footer>
            <banca-farmaci-ricerca-farmaco-component ref="cmpBancaFarmaci" @confermaSelezione="onConfermaSelezioneFarmaco" @annullaSelezione="onAnnullaSelezioneFarmaco" />

            <template #modal-cancel> </template>
        </b-modal>
    </div>
</template>
<script>
import BancaFarmaciRicercaFarmacoComponent from "../../bancafarmaci/components/BancaFarmaciRicercaFarmacoComponent.vue";
export default {
    components: { BancaFarmaciRicercaFarmacoComponent },
    data() {
        return {};
    },
    methods: {
        show() {
            this.$refs.mdlcodiceAic.show();
        },

        hide() {
            this.$refs.mdlcodiceAic.hide();
        },
        onShown() {
            console.log("Modale BancaFarmaci aperta");
            document.getElementById("boxSelezionaFarmaco").classList.remove("sa-bancafarmaci-hidden");
            document.getElementById("boxSelezionaFarmaco").classList.add("sa-bancafarmaci-visible");
        },
        onHidden() {
            console.log("Modale BancaFarmaci chiusa");
        },
        onConfermaSelezioneFarmaco(schedaFarmaco) {
            console.log("Farmaco selezionato dalla banca dati:", schedaFarmaco);
            const dataToEmit = {
                codiceAic: schedaFarmaco.codiceProdotto, //DA RIVEDERE SE CODICE AIC VABENE IL CODICE PRODOTTO
                nomeArticolo: schedaFarmaco.descrizione,
                descrizioneArticolo: schedaFarmaco.atcClassificazione.descrizione,
            };
            this.$emit("update", dataToEmit);
            this.hide();
        },

        onAnnullaSelezioneFarmaco() {
            console.log("Selezione farmaco annullata");
            this.hide();
        },
    },
};
</script>

<style>
.sa-modal-bancafarmaci .modal-dialog {
    max-width: 90%;
    width: 1200px;
}
.sa-modal-bancafarmaci .modal-body {
    padding: 0;
    height: 70vh;
    overflow: hidden;
}
</style>
